import { DownloadOutlined } from "@ant-design/icons";
import { Button, Tag } from "antd";
import Delete from "../assets/Delete.jsx";

// Table columns for uploaded documents
export const useColumns = (handleAction, totalData = 2) => {
  const documentColumns = [
    {
      title: "Document Type",
      dataIndex: "documentType",
      key: "documentType",
    },
    {
      title: "Document Name",
      dataIndex: "documentName",
      key: "documentName",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color="orange">{status}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="flex gap-2">
          <Button
            type="text"
            icon={<DownloadOutlined />}
            onClick={() => handleAction("download", record)}
            className="flex items-center justify-center"
            disabled={false}
          />
          {totalData > 1 && (
            <Button
              type="text"
              danger
              icon={<Delete />}
              onClick={() => handleAction("delete", record)}
              className="flex items-center justify-center"
            />
          )}
        </div>
      ),
    },
  ];

  return documentColumns;
};
